import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["authType", "name", "onContent", "onError", "onNoContent", "onVideoEngagement", "onVideoFinish", "onVideoPlay"];
import PropTypes from 'prop-types';
import { Frame } from './Frame';
import { useSyncStaticState } from '../hooks/staticWidgetHooks';
import { useSyncIFrameHeight } from '../hooks/syncIFrameHeightHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  Description: PropTypes.func,
  Link: PropTypes.func,
  Title: PropTypes.func,
  authType: PropTypes.oneOf(['app', 'public']),
  contentId: PropTypes.number,
  language: PropTypes.string,
  lessonId: PropTypes.number,
  name: PropTypes.string.isRequired,
  onContent: PropTypes.func,
  onError: PropTypes.func,
  onNoContent: PropTypes.func,
  onVideoEngagement: PropTypes.func,
  onVideoFinish: PropTypes.func,
  onVideoPlay: PropTypes.func,
  portalId: PropTypes.string,
  shortId: PropTypes.number,
  variant: PropTypes.oneOf(['default', 'video'])
};
export const StaticContentWidget = _ref => {
  let {
      authType,
      name,
      onContent,
      onError,
      onNoContent,
      onVideoEngagement,
      onVideoFinish,
      onVideoPlay
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    registerIFrame: registerSyncHeight,
    height
  } = useSyncIFrameHeight();
  const {
    registerIFrame: registerSyncDynamic
  } = useSyncStaticState({
    newState: Object.assign({
      authType
    }, rest),
    onContent,
    onError,
    onNoContent,
    onVideoEngagement,
    onVideoFinish,
    onVideoPlay
  });
  return /*#__PURE__*/_jsx(Frame, {
    height: height,
    name: name,
    refHandlers: [registerSyncHeight, registerSyncDynamic],
    targetWidget: authType === 'public' ? 'staticPublic' : 'static'
  });
};
StaticContentWidget.propTypes = propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
StaticContentWidget.defaultProps = {
  variant: 'default'
};